import { css } from '@emotion/react';

export default $ => css`
  .entity-editor-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .entity-editor-content {
      min-height: 200px;
      overflow: auto;
      position: relative;
    }
  }

  .cursor-move {
    cursor: grab;
  }

  .cursor-moving {
    cursor: grabbing;
  }

  .entity-editor .metadata-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .test-metadata-section {
      display: flex;
      align-items: center;
      gap: 0.3rem;

      > strong {
        font-weight: 500;
        white-space: nowrap;
      }

      > .form-control {
        width: 150px;
      }
    }
  }

  .drop-target {
    background: #f5f5f5;
    border: 1px dashed #dedede;
    border-radius: 15px;
    padding: 2rem;
  }
`;
